module.exports = __webpack_public_path__ + "static/media/ca.2dd02bb0.svg";